import { motion } from 'framer-motion'

import Icon from '@/ui/Icon'

import { MenuCategoryBorder, MenuCategoryLabel, MenuCategoryWrapper } from './MenuCategory.styles'

const MenuCategory = ({ icon, label, onClick, active }) => {
  return (
    <MenuCategoryWrapper active={active} onClick={onClick}>
      <MenuCategoryBorder as={motion.div} />
      {icon && <Icon size={50} name={icon} />}
      <MenuCategoryLabel>{label}</MenuCategoryLabel>
    </MenuCategoryWrapper>
  )
}
export default MenuCategory
